import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroller';
import './styles.css'


//we need to add some paging or lazy loading to this view
export default class GalleryPage extends Component {

    static contextTypes = {
        host: PropTypes.string
    };

    constructor(props, context) {
        super(props)
        this.beforeDateTime = '0'

        this.state = {
            status:0,
            flakes: [],
            hasMore:true
        }
    }

    load(page) {
        this.setState({ hasMore:false })
        var TAKE = 30;

        fetch(this.context.host + '/api/snowflakes?beforeDateTime=' + this.beforeDateTime + '&take=' + TAKE)
            .then((result) => {
                if (this.state.status !== result.status) {
                   this.setState({ status: result.status })
                }

                if (result.ok) {
                    return result.json();
                }
            }).then(data => {
                if (data) {
                    if (data.length > 0) {
                        this.beforeDateTime = data[data.length - 1].dateCreated
                    }
                    var flakes = this.state.flakes;
                    data.map(flake => {
                        flakes.push(flake)
                        return flake
                    });
                    console.log('total', data.length)
                    this.setState({
                        flakes: flakes,
                        hasMore: data != null && data.length === TAKE
                    })
                }
            }).catch(err => {
                console.log("error", err)
                this.setState({ status: 404 })
            })
    }

    render() {
        var flakeViews = []
        if (this.state.flakes) {
            flakeViews = this.state.flakes.map((flake, i) => {
                const maxLength = 140
                var message = flake.message
                if(message.length > maxLength) {
                    message = message.substring(0, maxLength) + '...'
                }

                return <Link key={flake.id} to={'/view/' + flake.id} className='snowflake-container'>
                    <div className="snowflake">
                        <img src={flake.imageUrl_Medium || flake.imageUrl} style={{ width: '300px', height: '300px' }} alt='snowflake'/>
                    </div>
                    <div className="message" style={{ background: flake.color }}>
                        <p>{message}</p>
                    </div>
                </Link>
            });
        }

        return (
            <InfiniteScroll className="gallery-container"
            pageStart={0}
            loadMore={this.load.bind(this)}
            hasMore={this.state.hasMore}
            >
                {this.state.status === 0 && <div className='snow-spinner'></div>}
                {this.state.status !== 0 && this.state.status !== 200 && <div className='try-again'><p>Sorry, we cannot load the snowflakes.</p> <button onClick={this.load.bind(this)}>Try Again</button></div>}
                {flakeViews}
        </InfiniteScroll>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/GalleryPage/index.js